import React, { useState } from 'react';

export default function AuthorList() {
  const [showAll, setShowAll] = useState(false);

  const mainAuthors = [
    { name: "Agam Shah✉", url: "#" },
    { name: "Siddhant Sukhani✉", url: "#", logo: "/static/logos/stanford.png", alt: "Stanford University" },
    { name: "Huzaifa Pardawala✉", url: "#" },
    { name: "Saketh Budideti†", url: "#" },
    { name: "Riya Bhadani†", url: "#" },
    { name: "Rudra Gopal†", url: "#" },
    { name: "Siddhartha Somani†", url: "#" },
    { name: "Rutwik Routu†", url: "https://scholar.google.com/citations?user=w38pbXQAAAAJ&hl=en", logo: "/static/logos/duke.png", alt: "Duke University" },
    { name: "Michael Galarnyk†", url: "https://scholar.google.co.in/citations?user=G567BHUAAAAJ&hl=en" },
    { name: "Soungmin Lee†", url: "#" },
  ];

  const midAuthors = [
    { name: "Arnav Hiray", url: "#" },
    { name: "Akshar Ravichandran", url: "#" },
    { name: "Eric Kim", url: "#" },
    { name: "Pranav Aluru", url: "#" },
    { name: "Joshua Zhang", url: "#" },
    { name: "Sebastian Jaskowski", url: "#", logo: "/static/logos/MSFT.png", alt: "Microsoft Corp." },
    { name: "Veer Guda", url: "#" },
    { name: "Meghaj Tarte", url: "#" },
    { name: "Liqin Ye", url: "#" },
    { name: "Spencer Gosden", url: "#" },
    { name: "Rachel Yuh", url: "#" },
    { name: "Sloka Chava", url: "#" },
    { name: "Sahasra Chava", url: "#" },
    { name: "Dylan Kelly", url: "#" },
    { name: "Aiden Chiang", url: "#" },
    { name: "Harsit Mittal", url: "#" },
  ];

  const finalAuthors = [
    { name: "Sudheer Chava", url: "https://scholar.google.com/citations?user=AXYf-i8AAAAJ&hl=en" },
  ];

  const handleToggle = () => setShowAll(!showAll);

  const displayed = showAll
    ? [...mainAuthors, ...midAuthors, ...finalAuthors]
    : [...mainAuthors, 'ELLIPSIS', ...finalAuthors];

  return (
    <div className="author-list text-center">
      {displayed.map((item, idx) => {
        if (item === 'ELLIPSIS') {
          return (
            <span
              key="ellipsis"
              className="author-ellipsis cursor-pointer text-blue-600 hover:underline"
              onClick={handleToggle}
            >
              …
            </span>
          );
        }
        const isLast = idx === displayed.length - 1;
        return (
          <React.Fragment key={idx}>
            <a
              className="author-link inline-flex items-center gap-1"
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.name}
              {item.logo && (
                <img
                  src={item.logo}
                  alt={item.alt}
                  className="h-4 w-auto object-contain inline-block align-middle ml-1"
                />
              )}
            </a>
            {!isLast && <span>,&nbsp;</span>}
          </React.Fragment>
        );
      })}

      {showAll && (
        <span
          className="author-ellipsis cursor-pointer text-blue-600 hover:underline ml-1"
          onClick={handleToggle}
        >
          (Collapse)
        </span>
      )}

      <div className="mt-4 text-sm text-gray-700">
        <span>
          ✉ Corresponding and Equal First Authors: {'{shahagam4, siddhantsukhani5, huzaifahp7}@gmail.com'}
        </span>
        <br />
        <span>† Indicates core contributors.</span>
      </div>
    </div>
  );
}
